import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box, {
  // Не прокидывать этот проп на DOM
  shouldForwardProp: (prop) => prop !== 'isOnlyRightSlot',
})<{ isOnlyRightSlot: boolean }>(({ isOnlyRightSlot }) => ({
  width: '100%',
  padding: '12px 0px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: isOnlyRightSlot ? 'flex-end' : 'space-between',
}));

export const ActionsStyled = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});
